import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from '@angular/core';
import { SearchService } from 'src/app/services/search.service';

export interface CollectionFilterItem {
  code: string;
  labelKey: string;
  enabled: boolean;
}

export interface CollectionFilterChange {
  /** Active collection codes (the ones with enabled = true). */
  codes: string[];
  /** Whether the S/service code is active — mirrors CMN_OLD. */
  serviceEnabled: boolean;
}

@Component({
  selector: 'app-collection-filter',
  templateUrl: './collection-filter.component.html',
  styleUrls: ['./collection-filter.component.scss'],
  standalone: false,
})
export class CollectionFilterComponent implements OnInit, OnChanges {
  /** Mirrors the external CMN_OLD state so S stays in sync. */
  @Input() serviceEnabled = false;

  @Output() collectionFilterChanged = new EventEmitter<CollectionFilterChange>();

  collections: CollectionFilterItem[] = [
    { code: 'A', labelKey: 'COLLECTION_ACTUEEL', enabled: true },
    { code: 'N', labelKey: 'COLLECTION_NIEUW', enabled: true },
    { code: 'O', labelKey: 'COLLECTION_UITLOOP', enabled: true },
    { code: '-', labelKey: 'COLLECTION_GEEN', enabled: true },
    { code: 'S', labelKey: 'COLLECTION_SERVICE', enabled: false },
  ];

  constructor(private searchService: SearchService) {}

  ngOnInit(): void {
    // Keep S in sync when the sidebar resets filters globally.
    this.searchService.resetFiltersEmitted$.subscribe(() => {
      this.collections.forEach((c) => {
        c.enabled = c.code !== 'S';
      });
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['serviceEnabled']) {
      const s = this.collections.find((c) => c.code === 'S');
      if (s) {
        s.enabled = !!this.serviceEnabled;
      }
    }
  }

  toggle(item: CollectionFilterItem): void {
    item.enabled = !item.enabled;

    const serviceItem = this.collections.find((c) => c.code === 'S');
    this.collectionFilterChanged.emit({
      codes: this.collections.filter((c) => c.enabled).map((c) => c.code),
      serviceEnabled: serviceItem ? serviceItem.enabled : false,
    });
  }
}
